import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Project } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  validateTimeRecordsUpToDate(
    request: Boundaries["validateTimeRecordsUpToDate"]["request"],
  ): void;
}

function useValidateTimeRecordsUpToDate(
  project: Identifiable<Project>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isValidateTimeRecordsUpToDateRequestPending(project),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isValidateTimeRecordsUpToDateRequestSuccess(project),
    ),
    isRequestFailure: useSelector(() =>
      selector.isValidateTimeRecordsUpToDateRequestFailure(project),
    ),
    validateTimeRecordsUpToDate: core.validateTimeRecordsUpToDate,
  };
}

export { useValidateTimeRecordsUpToDate };
